import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { ClipLoader } from 'react-spinners';
import Sorting from '../../enums/sorting-enum';
import { Collection } from '../../models/collection-model';
import ApiService from '../../services/api-service';
import SortComponent from '../sort/sort-component';
import './collections-component.scss';
import ClickableCardComponent from '../clickable-card/clickable-card-component';

export default function CollectionsComponent(): JSX.Element {
  const [collection, setCollection] = useState({} as Collection[]);
  const [collectionsLoading, setCollectionsLoading] = useState(true);
  const [sorting, setSorting] = useState(Sorting.None);

  useEffect(() => {
    const api = new ApiService();
    api.getCollectionsAsync().then((collectionsResponse) => {
      setCollection(collectionsResponse?.data);
      setCollectionsLoading(false);
    });
  }, []);

  const onCollectionNameSort = (sortingValue: Sorting) => {
    setSorting(sortingValue);
    if (sortingValue !== Sorting.None) {
      const indicator = sortingValue === Sorting.Ascending ? 1 : -1;
      setCollection([...collection.sort((item1, item2) => (item1.name > item2.name ? indicator : -1 * indicator))]);
    }
  };

  return (
    <div id="page-collections">
      <h1>Collections</h1>
      <div>
        {collectionsLoading ? (
          <ClipLoader loading={collectionsLoading} />
        ) : (
          collection.length && (
            <>
              <div className="row my-4">
                <Col xs={12} md={6} lg={3}>
                  <SortComponent
                    onSort={onCollectionNameSort}
                    ascendingCaption="Name A-Z"
                    descendingCaption="Name Z-A"
                    selectedValue={sorting}
                  />
                </Col>
              </div>

              <div key={sorting} className="d-flex flex-wrap tab-pane fade active show mt-3" id="allCollections-tab">
                <Row sm={1} md={2} lg={3} xl={4} className="g-4">
                  {collection.map((x) => {
                    const title = x.name || 'Collection name';
                    const text = x.description || 'No description provided';
                    const truncatedText = text.length >= 100 ? `${text.substring(0, 100)}...` : text;
                    const image = x.image || 'https://storage.googleapis.com/opensea-static/landing/cheeze-wizard.png';
                    const id = x.id || 'eSog';
                    const link = `/collection/${id}`;
                    return (
                      <Col className="d-flex align-items-stretch" key={`collection-${id}`}>
                        <ClickableCardComponent
                          link={link}
                          image={image}
                          title={title}
                          text={truncatedText}
                          isInternalRouting
                          buttonText="View collection"
                        />
                      </Col>
                    );
                  })}
                </Row>
              </div>
            </>
          )
        )}
      </div>
    </div>
  );
}
